import { Injectable, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { AudioData } from 'src/app/models/audioModel/audio-data.model';

@Injectable({
    providedIn: 'root'
})
export class AudioPlayerPortalService {

    private currentPlayerSubject = new BehaviorSubject<AudioData>(null);
    currentPlayer$ = this.currentPlayerSubject.asObservable();

    private removeCurrentPlayerSubject = new Subject();
    removeCurrentPlayer$ = this.removeCurrentPlayerSubject.asObservable();

    constructor() { }

    attach(data: AudioData) {
        this.currentPlayerSubject.next(data);
    }

}

interface ComponentReference {
    componentRef: any;
    containerRef: ViewContainerRef;
}